export default function getGraphQLErrorMessage(error, fallbackMsg = 'Something went wrong') {
    if (!error) {
        return fallbackMsg;
    }
    return (error.graphQLErrors[0]?.message ??
        error.clientErrors[0]?.message ??
        error.networkError?.message ??
        fallbackMsg);
}
